import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import "./showHira.scss";
import * as hiraService from "../../../services/HiraService";
import CardHira from "./../../../components/Card/CardHira/CardHira";
import Swal from "sweetalert2";
import Spinner from "../../../components/Spinner/Spinner";
import SearchBar from "./../../../components/Search/SearchBar";

const ShowHira = () => {
  const [hira, setHira] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    hiraService
      .getAllHira()
      .then((hiras) => {
        setHira(hiras);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Erreur lors du chargement des données Teny Zaraina :",
          error
        );
        setIsLoading(false);
      });
  }, []);

  const handleDelete = async (id) => {
    const isConfirmed = await Swal.fire({
      title: "Êtes-vous sûr de vouloir supprimer cette chanson ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer!",
      cancelButtonText: "Annuler",
    });

    if (isConfirmed.isConfirmed) {
      try {
        const response = await hiraService.deleteHiraById(id);
        if (response && response.status === 200) {
          Swal.fire("Chanson supprimée !", "Suppression réussie", "success");
          let newHira = hira.filter((hiras) => hiras.id !== id);
          setHira(newHira);
        } else {
          Swal.fire("Erreur", "La suppression a échoué", "error");
        }
      } catch (error) {
        console.error("Erreur lors de la suppression de la chanson :", error);
        Swal.fire("Erreur", "Une erreur s'est produite", "error");
      }
    }
  };

  const handleSearch = (value) => {
    setFilterTitle(value);
  };

  return (
    <div className="theme-component">
      <div className="add-button">
        <Link to="/hira/addHira">
          <Button>Créer Hira</Button>
        </Link>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "15px",
        }}
      >
        <SearchBar onSearch={handleSearch} />
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="theme">
          {hira && hira.length > 0 ? (
            hira
              .filter((hiras) =>
                hiras.lohateny.toLowerCase().includes(filterTitle.toLowerCase())
              )
              .map((hiras) => (
                <CardHira
                  key={hiras.id}
                  hiras={hiras}
                  handleDelete={() => handleDelete(hiras.id)}
                />
              ))
          ) : (
            <Typography variant="h6">Aucune donnée disponible</Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowHira;
